import { Button, ColumnTable } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import BadgeState from '../parts/BadgeState';
import { Survey, SurveyContext, surveyContextTexts } from '../types';

interface useColumnActions {
  isLoading: boolean;
  onClickEdit: (row: Survey) => void;
}

export default function useColumns(
  props: useColumnActions,
): ColumnTable<Survey>[] {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_SURVEY_RESULTS,
  );
  const { onClickEdit, isLoading } = props;

  return [
    {
      columnName: 'title',
      headerText: t('surveyResultList.headers.title'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'context',
      headerText: t('surveyResultList.headers.context'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (options) =>
        surveyContextTexts[options.row.context as SurveyContext] ||
        options.row.context,
    },
    {
      columnName: 'periodName',
      headerText: t('surveyResultList.headers.period'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'startDate',
      headerText: t('surveyResultList.headers.startDate'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'endDate',
      headerText: t('surveyResultList.headers.endDate'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'status',
      headerText: t('surveyResultList.headers.status'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return (
          <BadgeState
            status={row.status}
            text={t(`surveyResultList.status.${row.status}`)}
          />
        );
      },
    },
    {
      columnName: 'fullness',
      headerText: t('surveyResultList.headers.fullness'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'actions',
      headerText: t('surveyResultList.headers.actions'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return (
          <div className="d-flex justify-content-center">
            <Button
              size="sm"
              loading={isLoading}
              text="Descargar resultados"
              onClick={() => onClickEdit(row)}
            />
          </div>
        );
      },
    },
  ];
}
